"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryParams = useQueryParams;

var _reactRouterDom = require("react-router-dom");

var _react = require("react");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Leo Khramov
 */
// A custom hook that builds on useLocation to parse
// the query string for you.
function useQueryParams() {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  return (0, _react.useMemo)(function () {
    return new URLSearchParams(search);
  }, [search]);
}